import {
    addDays,
    differenceInCalendarWeeks,
    differenceInCalendarYears,
    differenceInDays,
    format,
    isSameDay,
    isSameMonth,
    isSameWeek,
    isSameYear,
    startOfMonth,
    startOfWeek,
    startOfYear
} from "date-fns";

class CardLogic {
    dateOptions = {weekStartsOn:1};

    showMyTasksInToday = false;
    showPlannedNowInTodo = false;

    Status = {
        FUTURE: 'Future',
        TODO: 'To do',
        DONE: 'Done',
    };

    Time = {
        PAST: 'past',
        PRESENT: 'present',
        FUTURE: 'future',
    };

    labels = {
        done: 'Completed',
        today: 'My tasks today',
        todo: 'To do',
        now: 'Next',
        later: 'Later',
    };

    constructor() {
        this.compareGroup = this.compareGroup.bind(this);
    }

    groupByPlannedStart(categories, today, user) {
        console.log("CardLogic groupByPlannedStart", categories, ", today:", today, ", user:", user);

        let cardGroups = new Set();
        categories.forEach(category => {
            category.cards.forEach(card => {
                cardGroups.add(this.cardGroup(card, today, user));
            });
        });
        let sortedGroups = Array.from(cardGroups);
        sortedGroups.sort(this.compareGroup);
        console.log("CardLogic groupByPlannedStart sortedGroups:", sortedGroups);

        let groups = [];
        sortedGroups.forEach(groupDate => {
            let dateGroup = this.buildDateGroup(today, groupDate);

            let categoryGroup;
            categories.forEach(category => {
                let copy = {...category, group: dateGroup.label, cards: []};
                category.cards.forEach(card => {
                    if(this.cardGroup(card, today, user) === groupDate) {
                        copy.cards.push(card);
                    }
                });

                if(copy.cards.length > 0) {
                    if(!categoryGroup) {
                        categoryGroup = {
                            name: dateGroup.label,
                            time: dateGroup.time,
                            categories: [],
                        }
                        groups.push(categoryGroup);
                    }
                    categoryGroup.categories.push(copy);
                }
            });
        });

        console.log("CardLogic groupByPlannedStart groups:", groups);
        return groups;
    }

    groupByDateAndCategory(cards, today, user) {
        console.log("CardLogic groupByDateAndCategory", today, cards, user);

        let groups = {};
        cards.forEach(card => {
            let g = this.cardGroup2(card, today, user);
            let group = g.group;
            if(!groups[group]) {
                groups[group] = {
                    ...g,
                    categories: {},
                };
            }

            let category = card.parent;
            if(!groups[group].categories[category.id]) {
                groups[group].categories[category.id] = {
                    category: category,
                    cards: [],
                };
            }

            groups[group].categories[category.id].cards.push(card);
        });

        let compareGroupWithToday = (a, b) => {
            if (a === b) {
                return 0;
            } else if (a === this.labels.today) {
                // a < b => today < b
                return today.localeCompare(b);
            } else if (b === this.labels.today) {
                // a < b => a < today
                return a.localeCompare(today);
            } else if (a === this.labels.todo) {
                // a < b => today < b
                return today.localeCompare(b);
            } else if (b === this.labels.todo) {
                // a < b => a < today
                return a.localeCompare(today);
            } else if (a === this.labels.now) {
                return today.localeCompare(b);
            } else if (b === this.labels.now) {
                return a.localeCompare(today);
            } else if (a === this.labels.later) {
                return 1;
            } else if (b === this.labels.later) {
                return -1;
            } else {
                return a.localeCompare(b);
            }
        };

        let sortedGroups = Array.from(Object.keys(groups));
        sortedGroups.sort(compareGroupWithToday);
        console.debug("sortedGroups: ", sortedGroups);

        return sortedGroups.map(group => {
            let dateGroup = groups[group];
            let resultGroup = {
                name: dateGroup.label,
                time: dateGroup.time,
                categories: [],
            };

            Object.values(groups[group].categories).forEach(c => {
                let resultCategory = {...c.category};
                resultGroup.categories.push(resultCategory);
                resultCategory.cards = c.cards;
                // console.debug("group:", group, ", category:", category.id, category.name, ", cards:", cards);
            });

            return resultGroup;
        });
    }

    cardGroup(card, today, user) {
        let status = (this.showPlannedNowInTodo ? card.status2 : card.status);
        if (status === this.Status.FUTURE) {
            if (card.plannedStart) {
                if (today) {
                    if(card.plannedStart <= today) {
                        return this.labels.now;
                    } else {
                        let groupDate = this.dateGroup(today, card.plannedStart, this.Time.FUTURE);
                        console.info("CardLogic.cardGroup plannedStart:", card.plannedStart, ", today:", today, "->", groupDate);
                        return this.timeToDate(groupDate);
                    }
                } else {
                    console.info("CardLogic.cardGroup plannedStart:", card.plannedStart);
                    return card.plannedStart;
                }
            } else {
                return 'Later';
            }
        } else if(status === this.Status.TODO) {
            if (card.status === this.Status.DONE) {
                // Done this week. Show in Today or This week.
                if (this.timeToDate(card.updatedTime) !== today) {
                    return 'To do';
                }
            }

            if(this.showMyTasksInToday) {
                let myDailyTasks = (card.tasks || []).filter(task =>
                    user && task.assigned.length > 0 && task.assigned[0].id === user.id && task.status === 'To do'
                );

                if (myDailyTasks.length > 0) {
                    return this.labels.today;
                } else {
                    return this.labels.todo;
                }
            } else {
                return this.labels.todo;
            }
        } else if(status === this.Status.DONE) {
            // archiveTime = next week after the card became DONE
            let finishedDate = this.timeToDate(card.updatedTime);
            // console.log("CardLogic cardGroup: Ready, finishedDate: ", finishedDate, ", today:", today);

            if(finishedDate) {
                if (today) {
                    let groupDate = this.dateGroup(today, finishedDate, this.Time.PAST);
                    let ret = this.timeToDate(groupDate);
//                    console.log("CardLogic cardGroup: DONE, finishedDate: ", finishedDate, ", today:", today, ", groupDate:", groupDate, ", ret:", ret);
                    return ret;
                }
            }

            return status;
        } else {
            return status;
        }
    }

    cardGroup2(card, today, user) {
        let status = (this.showPlannedNowInTodo ? card.status2 : card.status);
        if (status === this.Status.FUTURE) {
            if (card.plannedStart) {
                if (today) {
                    if(card.plannedStart <= today) {
                        return {group: this.labels.now, time: this.Time.FUTURE, label: this.labels.now};
                    } else {
                        let todayDate = new Date(today);
                        let dateDate = new Date(card.plannedStart);
                        if (isSameDay(dateDate, todayDate)) {
                            return {group: this.timeToDate(dateDate), time: this.Time.FUTURE, label: this.labels.today};
                        } else if (differenceInDays(dateDate, todayDate) === 1) {
                            return {group: this.timeToDate(dateDate), time: this.Time.FUTURE, label: 'Tomorrow'};
                        } else if (isSameWeek(dateDate, todayDate, this.dateOptions)) {
                            return {group: this.timeToDate(dateDate), time: this.Time.FUTURE, label: format(dateDate, 'EEEE')};
                        } else if (differenceInCalendarWeeks(dateDate, todayDate, this.dateOptions) === 1) {
                            return {group: this.timeToDate(startOfWeek(dateDate, this.dateOptions)), time: this.Time.FUTURE, label: 'Next week'};
                        } else if (isSameMonth(dateDate, todayDate)) {
                            let weekStart = startOfWeek(dateDate, this.dateOptions);
                            let weekEnd = addDays(weekStart, 6);
                            let label = `${format(weekStart, 'MMM d')} - ${format(weekEnd, 'MMM d')}`;
                            return {group: this.timeToDate(startOfWeek(dateDate, this.dateOptions)), time: this.Time.FUTURE, label: label};
                        } else if (isSameYear(dateDate, todayDate)) {
                            // TODO If the start of the month is the same day as the start of the week, the card will be shown in Next week instead of the month.
                            return {group: this.timeToDate(startOfMonth(dateDate)), time: this.Time.FUTURE, label: format(dateDate, 'MMMM')};
                        } else if (differenceInCalendarYears(dateDate, todayDate) === 1) {
                            return {group: this.timeToDate(addDays(startOfMonth(dateDate), 8)), time: this.Time.FUTURE, label: format(dateDate, 'MMMM yyyy')};
                        } else {
                            return {group: this.timeToDate(addDays(startOfYear(dateDate), 1)), time: this.Time.FUTURE, label: format(dateDate, 'yyyy')};
                        }
                    }
                } else {
                    console.info("CardLogic.cardGroup plannedStart:", card.plannedStart);
                    return {group: card.plannedStart, time: this.Time.FUTURE, label: this.labels.now};
                }
            } else {
                return {group: this.labels.later, time: this.Time.FUTURE, label: this.labels.later};
            }
        } else if(status === this.Status.TODO) {
            if(this.showMyTasksInToday) {
                let myDailyTasks = (card.tasks || []).filter(task =>
                    user && task.assigned.length > 0 && task.assigned[0].id === user.id && task.status === 'To do'
                );

                if (myDailyTasks.length > 0) {
                    return {group: this.labels.today, time: this.Time.PRESENT, label: this.labels.today};
                }
            }

            return {group: this.labels.todo, time: this.Time.PRESENT, label: this.labels.todo};
        } else if(status === this.Status.DONE) {
            let finishedDate = this.timeToDate(card.archiveTime || card.updatedTime);
            if(finishedDate && today) {
                let ret = this.timeToDate(finishedDate);
                let dateDate = new Date(ret);
                let todayDate = new Date(today);
                let label = this.completedLabel(dateDate, todayDate);
                console.log("CardLogic.completedLabel(archiveTime:", card.archiveTime, ", updatedTime:", card.updatedTime, today, "):", ret, " -> ", label);
                return {group: label, time: this.Time.PAST, label: label};
            }

            return {group: status, time: this.Time.PAST, label: status};
        } else {
            return {group: status, time: this.Time.FUTURE, label: 'Unknown'};
        }
    }

    completedLabel(date, today) {
        if (isSameDay(date, today, this.dateOptions)) {
            return "Completed today";
        } else if (isSameWeek(date, today, this.dateOptions)) {
            return "Completed this week";
        } else if (differenceInCalendarWeeks(date, today, this.dateOptions) === -1) {
            return "Completed last week";
        } else {
            return this.labels.done;
        }
    }

    compareGroup(a, b) {
        if (a === b) {
            return 0;
        } else if (a === this.labels.today) {
            return -1;
        } else if (b === this.labels.today) {
            return 1;
        } else if (a === this.labels.todo) {
            return -1;
        } else if (b === this.labels.todo) {
            return 1;
        } else if (a === this.labels.now) {
            return -1;
        } else if (b === this.labels.now) {
            return 1;
        } else if (a === this.labels.later) {
            return 1;
        } else if (b === this.labels.later) {
            return -1;
        } else {
            return a.localeCompare(b);
        }
    }

    buildDateGroup(todayString, dateString) {
        if(dateString === this.labels.todo || dateString === this.labels.today) {
            return {time: this.Time.PRESENT, label: dateString};
        } else if(dateString === this.labels.later || dateString === this.labels.now) {
            return {time: this.Time.FUTURE, label: dateString};
        } else if(dateString === this.labels.done) {
            return {time: this.Time.PAST, label: dateString};
        }

        let date = new Date(dateString);
        let today = new Date(todayString);
        let period;
        if(date > today) {
            period = this.Time.FUTURE;
        } else if(date === today) {
            period = this.Time.PRESENT;
        } else {
            period = this.Time.PAST;
        }

        if(period === this.Time.PAST) {
            if (isSameDay(date, today)) {
                return {time: this.Time.PAST, label: "Completed today"};
            } else if (isSameWeek(date, today, this.dateOptions)) {
                return {time: this.Time.PAST, label: "Completed this week"};
            } else if (differenceInCalendarWeeks(date, today, this.dateOptions) === -1) {
                return {time: this.Time.PAST, label: "Completed last week"};
            }
        }

        if (isSameDay(date, today)) {
            return {time: this.Time.PRESENT, label: this.labels.today};
        } else if (differenceInDays(date, today) === 1) {
            return {time: period, label: 'Tomorrow'};
        } else if (isSameWeek(date, today, this.dateOptions)) {
            return {time: period, label: format(date, 'EEEE')};
        } else if (differenceInCalendarWeeks(date, today, this.dateOptions) === 1) {
            return {time: period, label: 'Next week'};
        } else if (isSameMonth(date, today)) {
            let weekStart = startOfWeek(date, this.dateOptions);
            let weekEnd = addDays(weekStart, 6);
            return {time: period, label: `${format(weekStart, 'MMM d')} - ${format(weekEnd, 'MMM d')}`};
        } else if (isSameYear(date, today)) {
            return {time: period, label: format(date, 'MMMM')};
        } else if (differenceInCalendarYears(date, today) === 1) {
            return {time: period, label: format(date, 'MMMM yyyy')};
        } else {
            return {time: period, label: format(date, 'yyyy')};
        }
    }

    timeToDate(time) {
        if(!time) {
            return time;
        } else if(time instanceof Date) {
            return time.toLocaleDateString("sv-SE");
        } else {
            return new Date(time).toLocaleDateString("sv-SE");
        }
    }

    dateGroup(todayString, dateString, time) {
        let today = new Date(todayString);
        let date = new Date(dateString);

        if(time === this.Time.PAST) {
            if (isSameWeek(date, today, this.dateOptions)) {
                return startOfWeek(date, this.dateOptions);
            }
            // TODO Since else is not handled here, it will continue below and use future logic for past periods.
        } else if(time === this.Time.PRESENT) {
            return today;
        }

        if (isSameDay(date, today)) {
            return date;
        } else if (differenceInDays(date, today) === 1) {
            return date;
        } else if (isSameWeek(date, today, this.dateOptions)) {
            return date;
        } else if (differenceInCalendarWeeks(date, today, this.dateOptions) === 1) {
            return startOfWeek(date, this.dateOptions);
        } else if (isSameMonth(date, today)) {
            return startOfWeek(date, this.dateOptions);
        } else if (isSameYear(date, today)) {
            // TODO If the start of the month is the same day as the start of the week, the card will be shown in Next week instead of the month.
            return startOfMonth(date);
        } else if (differenceInCalendarYears(date, today) === 1) {
            return addDays(startOfMonth(date), 8);
        } else {
            return addDays(startOfYear(date), 1);
        }
    }
}

export default CardLogic;
